import { render, staticRenderFns } from "./diamond.vue?vue&type=template&id=0284896e&scoped=true"
import script from "./diamond.vue?vue&type=script&lang=js"
export * from "./diamond.vue?vue&type=script&lang=js"
import style0 from "./diamond.vue?vue&type=style&index=0&id=0284896e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284896e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0284896e')) {
      api.createRecord('0284896e', component.options)
    } else {
      api.reload('0284896e', component.options)
    }
    module.hot.accept("./diamond.vue?vue&type=template&id=0284896e&scoped=true", function () {
      api.rerender('0284896e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/diamond.vue"
export default component.exports